import { NavItem } from '@components/v2/layout/AppTemplate/appTemplate.types';
import Chip from '@components/v2/ui/Chip/Chip';
import Icon from '@components/v2/ui/Icon/Icon';
import ListItemButton from '@components/v2/ui/List/ListItemButton';
import ListItemIcon from '@components/v2/ui/List/ListItemIcon';
import ListItemText from '@components/v2/ui/List/ListItemText';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../modules/translation/TranslationContext';
import { AppTemplateTestIds } from '../../../../../../../../utils/testIds/appTemplate.testIds';
import { useSidebarNavItemStyles } from './sidebarNavItem.styles';

interface SidebarNavItemProps {
  item: NavItem;
  isCollapsed: boolean;
  isActive: boolean;
  onClick: (item: NavItem) => void;
}

const SidebarNavItem = ({ item, isCollapsed, isActive, onClick }: SidebarNavItemProps) => {
  const { classes } = useSidebarNavItemStyles({ isCollapsed });
  const { translate } = useTranslation();

  const linkProps = item.pathname ? { to: item.pathname } : {};
  const testId =
    item.testId ??
    (item.pathname ? `${AppTemplateTestIds.NAV_ITEM_PREFIX}${item.pathname}` : undefined);

  return (
    <Tooltip
      TooltipContent={item.label}
      placement="right"
      disabled={!isCollapsed}
      delay={0}
      fullWidth
      tabIndex={-1}
    >
      <ListItemButton
        isActive={isActive}
        className={classes.button}
        testId={testId}
        onClick={() => onClick(item)}
        {...linkProps}
      >
        {item.icon && (
          <ListItemIcon className={classes.icon}>
            <Icon icon={item.icon} />
          </ListItemIcon>
        )}
        <ListItemText primary={item.label} className={classes.text} />
        {item.isNew && !isCollapsed && (
          <Chip
            size="extraSmall"
            label={translate(LangEnum.GLOBAL_NEW)}
            className={classes.newChip}
          />
        )}
      </ListItemButton>
    </Tooltip>
  );
};

export default SidebarNavItem;
